import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, ActivatedRouteSnapshot, Router } from '@angular/router';

import { UserRole } from '../models/enums/user-role.enum';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canLoad(): boolean {
    if (this.authService.isUserLoggedIn()) {
      return true;
    }
    return false;
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.authService.isUserLoggedIn()) {
      if (
        route.routeConfig?.path === 'display' &&
        route.queryParamMap.has('authToken') &&
        route.queryParamMap.has('refreshToken')
      ) {
        return true;
      }

      this.router.navigate(['auth', 'login']);
      return false;
    }

    if (
      this.authService.isUserInOneOfRoles([UserRole.Display, UserRole.IndividualDisplay]) &&
      route.routeConfig?.path !== 'display'
    ) {
      this.router.navigate(['/display']);
      return false;
    }

    if (route.data['roles']) {
      return this.authService.isUserInOneOfRoles(route.data['roles']);
    }

    return true;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot): boolean {
    return this.canActivate(childRoute);
  }
}
